<template>
	<div>
		<CCard>
			<CCardHeader> ShipNotifyCustomer / SHPNOTCUS </CCardHeader>

			<CCardBody>
				<CRow>
					<CCol md="4">
						<GFormGroup class="form-group">
							<template #label>
								<label>Transporteur</label>
							</template>
							<template #input>
								<GTreeView
									v-on:update:selected="data => (carrier = data)"
									:local-data="carriers"
									:multiple="false" />
							</template>
						</GFormGroup>
					</CCol>

					<CCol md="4">
						<vc-date-picker
							v-model="dateSHPNOTCUS"
							mode="date"
							timezone="UTC"
							:model-config="datepickerConfig">
							<template v-slot="{ inputValue, inputEvents }">
								<CInput
									label="Date de décollage du vol"
									type="text"
									name="sendingDate"
									:value="inputValue"
									v-on="inputEvents" />
							</template>
						</vc-date-picker>
					</CCol>
				</CRow>
				<CRow>
					<CCol md="6">
						<GLoadingButton
							:loading="loadingSHPNOTCUS"
							color="primary"
							class="d-inline mt-2"
							label="Télécharger"
							@click="onSubmitSHPNOTCUS('download')" />
						<GLoadingButton
							:loading="loadingSHPNOTCUS"
							color="primary"
							label="Transmettre à Chronopost"
							class="d-inline mt-2 ml-2"
							@click="onSubmitSHPNOTCUS('chronopost')" />
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard>
			<CCardHeader> EDI / Fichier de mise en vol </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol md="3">
						<CFormGroup class="form-group">
							<template #label>
								<label>Concept</label>
							</template>
							<template #input>
								<GSelect
									:options="concepts"
									v-on:update:value="data => (concept = data.value)" />
							</template>
						</CFormGroup>
					</CCol>
					<CCol md="3">
						<vc-date-picker
							v-model="dateEDI"
							mode="date"
							timezone="UTC"
							:model-config="datepickerConfig">
							<template v-slot="{ inputValue, inputEvents }">
								<CInput
									label="Date du vol"
									type="text"
									name="flightDate"
									:value="inputValue"
									v-on="inputEvents" />
							</template>
						</vc-date-picker>
					</CCol>
					<CCol md="6">
						<CFormGroup class="form-group">
							<template #label>
								<label>Vol</label>
							</template>
							<template #input>
								<GSelect
									:options="flights"
									v-on:update:value="data => (flightEDI = data.value)" />
							</template>
						</CFormGroup>
					</CCol>
				</CRow>

				<CRow>
					<CCol md="6">
						<GLoadingButton
							:loading="loadingEDI"
							color="primary"
							label="Télécharger"
							class="d-inline mt-2"
							@click="onSubmitEdi" />
						<GLoadingButton
							:loading="loadingEDI"
							color="primary"
							label="Transmettre à Chronopost"
							class="d-inline mt-2 ml-2"
							@click="onSubmitEdiChronopost" />
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard>
			<CCardHeader>Travail en cours</CCardHeader>
			<CCardBody>
				<GDataTableRemote
					ref="mainTable"
					remote-url="/api/shipnotcus_jobs"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #finished="{ item }">
						<td class="text-center">
							<CIcon
								:name="item.finished ? 'cil-check' : 'cil-x'"
								:class="item.finished ? 'text-success' : 'text-danger'" />
						</td>
					</template>
					<template #status="{ item }">
						<td v-if="item.method == 'download'">
							<a
								target="_blank"
								download="true"
								:href="
									item.status.replace('Vous pouvez télécharger avec le lien suivant: ', '')
								"
								>Télécharger</a
							>
						</td>
						<td v-else>{{ item.status }}</td>
					</template>
				</GDataTableRemote>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import GTreeView from '../../../../components/ghostlexly-components/GTreeView';
	import GFormGroup from '../../../../components/ghostlexly-components/GComponentsLibraries/VueFiles/GFormGroup';
	import GLoadingButton from '../../../../components/ghostlexly-components/GLoadingButton';
	import GSelect from '@/components/ghostlexly-components/GInputs/GSelect';
	import GDataTableRemote from '@/components/ghostlexly-components/GDataTableRemote';
	import mercure from '@/components/ghostlexly-components/libs/mercure';

	export default {
		components: { GDataTableRemote, GSelect, GLoadingButton, GFormGroup, GTreeView },
		data() {
			this.statusOptions = [
				{ value: 'En attente', label: 'En attente' },
				{ value: 'Transmis', label: 'Transmis' },
				{ value: 'Terminé', label: 'Terminé' },
				{ value: 'Vous pouvez télécharger avec le lien suivant:', label: 'Téléchargable' },
			];
			return {
				fields: [
					{ key: 'id', label: 'ID', sortable: true },
					{ key: 'carrier', label: 'Transporteur' },
					{ key: 'takeoffDate', label: 'Date du décollage', type: 'date' },
					{ key: 'createdAt', label: 'Demandé le', type: 'datetime' },
					{
						key: 'status',
						label: 'Statut',
						type: 'select',
						filterSelectOptions: this.statusOptions,
					},
					{ key: 'finished', label: 'Terminé', filter: false },
				],

				dateSHPNOTCUS: this.$moment().format('YYYY-MM-DD'),
				dateEDI: this.$moment().format('YYYY-MM-DD'),
				flightEDI: null,
				flights: [],
				loadingSHPNOTCUS: false,
				loadingEDI: false,
				carriers: [
					{ '@id': 'CHRONO13', name: 'CHRONO13 - Chrono Avant 13H (Reunion => France)' },
					{ '@id': 'INT', name: 'INT - Chrono Express (Reunion => Reunion)' },
					{ '@id': 'CHRONORELAIS', name: 'Chrono Relais' },
				],
				carrier: null,
				concepts: [
					{ value: 'order.colipays', label: 'Colipays' },
					{ value: 'order.colikado', label: 'Colikado' },
					{ value: 'order.aupaysdesfleurs', label: 'Au pays des fleurs' },
				],
				concept: null,
				datepickerConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
			};
		},

		watch: {
			dateEDI: {
				immediate: true,
				handler(val) {
					this.loadingEDI = true;
					this.flightEDI = null;

					this.$axios.get(`/api/flights?departureTime=${val}`).then(res => {
						this.flights = res.data['hydra:member'].map(item => {
							return { label: item.LTA, value: item.id };
						});
						this.loadingEDI = false;
					});
				},
			},
		},

		mounted() {
			mercure.watch(this, '/api/shipnotcus_jobs/{id}', function () {
				this.$refs.mainTable.refresh();
			});
		},

		methods: {
			onSubmitSHPNOTCUS($method) {
				this.loadingSHPNOTCUS = true;
				this.$axios
					.post(`/api/shipnotcus_jobs`, {
						carrier: this.carrier,
						takeoffDate: this.dateSHPNOTCUS,
						method: $method,
					})
					.then(res => {
						this.$toast.success('Demande en cours de traitement !');
					})
					.catch(err => {
						console.log(err);
						this.$toast.error(err.response.data['hydra:description']);
					})
					.finally(() => {
						this.loadingSHPNOTCUS = false;
					});
			},

			onSubmitEdi() {
				this.loadingEDI = true;
				// download the file
				this.$axios
					.get(
						`/api/chronopost/generate/edi/download/${this.concept}/${this.flightEDI
							.toString()
							.split('/')
							.pop()}`,
						{
							responseType: 'blob',
						}
					)
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.csv';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();
							this.loadingEDI = false;
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
							this.loadingEDI = false;
						});
					});
			},

			onSubmitEdiChronopost() {
				this.loadingEDI = true;

				this.$axios
					.get(
						`/api/chronopost/generate/edi/chronopost/${this.concept}/${this.flightEDI
							.toString()
							.split('/')
							.pop()}`
					)
					.then(() => {
						this.loadingEDI = false;
						this.$toast.success('Transmis à Chronopost avec succès !');
					})
					.catch(err => {
						this.loadingEDI = false;
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
		},
	};
</script>

<style scoped>
	.info {
		max-width: 400px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.popover-old-body {
		overflow: scroll;
		height: 350px;
	}
</style>
